module.exports = __webpack_public_path__ + "img/ic-tick-bright.3dd3c21c.svg";